import React from "react";

const Blog = () => {
  return (
    <div>
      <section className="min-h-screen">
        <div className="container flex flex-col justify-center px-4 py-8 mx-auto md:p-8">
          <h2 className="text-2xl font-semibold sm:text-4xl mb-5">
            Frequently Asked Questions
          </h2>
          <div className="space-y-4">
            <details className="w-full border rounded-lg">
              <summary className="px-4 py-6 focus:outline-none focus-visible:ring-violet-400 text-2xl font-medium">
                React vs. Angular vs. Vue?
              </summary>
              <p className="px-4 py-6 pt-0 ml-4 -mt-4 dark:text-gray-400 text-lg">
                React developed by Facebook, was initially released in 2013.
                Facebook uses React extensively in their products (Facebook,
                Instagram, and WhatsApp). Similar to Vue, the React developers
                also announce their newest version on theAngular developed by
                Google, was first released in 2010, making it the oldest of the
                lot. It is a TypeScript-based JavaScript framework. A
                substantial shift occurred in 2016 on the release of Angular 2
                (and the dropping of the “JS” from the original name –
                AngularJS). Angular 2+ is known as just Angular. Although
                AngularJS (version 1) still gets updates, we will focus the
                discussion on Angular. Vue also known as Vue.js, is the youngest
                member of the group. It was developed by ex-Google employee Evan
                You in 2014. Over the last several years, Vue has seen a
                substantial shift in popularity, even though it doesn’t have the
                backing of a large company.
              </p>
            </details>
            <details className="w-full border rounded-lg">
              <summary className="px-4 py-6 focus:outline-none focus-visible:ring-violet-400 text-2xl font-medium">
              How does prototypical inheritance work?
              </summary>
              <div className="px-4 py-6 pt-0 ml-4 -mt-4 dark:text-gray-400 text-lg">
                <p>
                In programming, we often want to take something and extend it.For instance, we have a user object with its properties and methods, and want to make admin and guest as slightly modified variants of it. We'd like to reuse what we have in user, not copy/reimplement its methods, just build a new object on top of it.Prototypal inheritance is a language feature that helps in that.Accessor properties are an exception, as assignment is handled by a setter function. So writing to such a property is actually the same as calling a functio
                </p>
              </div>
            </details>
            <details className="w-full border rounded-lg">
              <summary className="px-4 py-6 focus:outline-none focus-visible:ring-violet-400 text-2xl font-medium">
              What is a unit test? Why should we write unit tests?
              </summary>
              <div className="px-4 py-6 pt-0 ml-4 -mt-4 dark:text-gray-400 text-lg">
                <p>
                Unit Testing is a type of software testing where individual units or components of a software are tested.The purpose is to validate that each unit of the software code performs as expected.Unit Testing is done during the development(coding phase) of an application by the developers.Unit Tests isolate a section of code and verify its correctness.A unit may be an individual function, method, procedure, module, or object. Unit tests save time and money. Usually, we tend to test the happy path more than the unhappy path. If you release such an app without thorough testing, you would have to keep fixing issues raised by your potential users. The time to fix these issues could've been used to build new features or optimize the existing system. Bear in mind that fixing bugs without running tests could also introduce new bugs into the system.
                </p>
              </div>
            </details>

            <details className="w-full border rounded-lg">
              <summary className="px-4 py-6 focus:outline-none focus-visible:ring-violet-400 text-2xl font-medium">
              What is the different ways to manage a state in a react application?
              </summary>
              <p className="px-4 py-6 pt-0 ml-4 -mt-4 dark:text-gray-400 text-lg">
              Local (UI) state: Local state is data we manage in one or another component.Local state is most often managed in React using the useState hook.For example, local state would be needed to show or hide a modal component or to track values for a form component, such as form submission, when the form is disabled and the values of a form's inputs. Global (UI) state: Global state is data we manage across multiple components. Global state is necessary when we want to get and update data anywhere in our app, or in multiple components at least.
              </p>
            </details>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Blog;
